import type { PricedRule } from './practiceProductPricing';

export function rulesForVersion(rules: PricedRule[], versionId: string): PricedRule[] {
    return rules.filter(
        (rule) => rule.appliesToVersionId === null || rule.appliesToVersionId === versionId
    );
}

// Per-rule deltas in the same order applyRules uses, for price breakdowns.
export function ruleBreakdown(
    priceCents: number,
    rules: PricedRule[]
): { rule: PricedRule; deltaCents: number }[] {
    const steps: { rule: PricedRule; deltaCents: number }[] = [];
    let price = priceCents;
    for (const rule of rules) {
        if (rule.discountType === 'percentage') {
            const next = Math.round(price * (1 - rule.discountValue / 100));
            steps.push({ rule, deltaCents: price - next });
            price = next;
        }
    }
    for (const rule of rules) {
        if (rule.discountType === 'flat') {
            const delta = Math.min(price, Math.round(rule.discountValue * 100));
            steps.push({ rule, deltaCents: delta });
            price -= delta;
        }
    }
    return steps;
}
